const cartDrawerDiscount = () => {
    const events = ['load', 'frank-green:cart-reloaded'];
    events.forEach((event) => {
        window.addEventListener(event, () => {
            discountInputForm();
        });
    });
    const discountInputForm = () => {
        const applyBtn = document.querySelector('#apply-discount-btn');
        const discountCodeError = document.querySelector('#discount-code-error');
        const discountCodeWrapper = document.querySelector('#applied-discount-code .applied-discount-code-wrapper');
        const discountCodeInput = document.querySelector('#discount-code-input');
        let authorization_token;
        if (applyBtn) {
            applyBtn.addEventListener('click', function (e) {
                e.preventDefault();
                applyDiscount(discountCodeInput.value);
            });
        }
        const applyDiscount = (code) => {
            if (applyBtn) {
                applyBtn.innerHTML = "Applying <div class='loader'></div>";
                applyBtn.style.pointerEvents = 'none';
            }
            fetch('/payments/config', {
                method: 'GET',
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (data) {
                const checkout_json_url = '/wallets/checkouts/';
                authorization_token = btoa(data.paymentInstruments.accessToken);
                fetch('/cart.js', {})
                    .then(function (res) {
                    return res.json();
                })
                    .then(function (data) {
                    const body = {
                        checkout: {
                            //@ts-ignore
                            country: Shopify.country,
                            discount_code: code,
                            line_items: data.items,
                            //@ts-ignore
                            presentment_currency: Shopify.currency.active,
                        },
                    };
                    fetch(checkout_json_url, {
                        headers: {
                            accept: '*/*',
                            'cache-control': 'no-cache',
                            authorization: 'Basic ' + authorization_token,
                            'content-type': 'application/json, text/javascript',
                            pragma: 'no-cache',
                            'sec-fetch-dest': 'empty',
                            'sec-fetch-mode': 'cors',
                            'sec-fetch-site': 'same-origin',
                        },
                        referrerPolicy: 'strict-origin-when-cross-origin',
                        method: 'POST',
                        mode: 'cors',
                        credentials: 'include',
                        body: JSON.stringify(body),
                    })
                        .then(function (response) {
                        return response.json();
                    })
                        .then(function (data) {
                        if (data.checkout && data.checkout.applied_discounts.length > 0) {
                            const discountApplyUrl = '/discount/' + code + '?v=' + Date.now() + '&redirect=/checkout/';
                            fetch(discountApplyUrl, {})
                                .then(function (response) {
                                return response.text();
                            })
                                .then(() => {
                                if (discountCodeWrapper)
                                    discountCodeWrapper.style.display = 'inline-flex';
                                if (discountCodeError)
                                    discountCodeError.innerHTML = '';
                            })
                                .then(() => {
                                window.dispatchEvent(new CustomEvent('frank-green:discount-applied'));
                            });
                        }
                        else {
                            if (discountCodeError)
                                discountCodeError.innerHTML = 'Please Enter Valid Coupon Code.';
                        }
                    })
                        //@ts-ignore
                        .finally(function (params) {
                        if (applyBtn) {
                            applyBtn.innerHTML = 'Apply';
                            applyBtn.style.pointerEvents = 'all';
                        }
                    });
                });
            });
        };
    };
};
export { cartDrawerDiscount };
